import SimpleSchema from 'simpl-schema';

import store from '../../config/configureStore';
import { incidentHasArrestee, incidentHasKnownOffender } from '../helpers/incidentHelper';
import { getCategoryOfCode } from 'utils/functions';

export const incIncidentSchema = () => {
  SimpleSchema.setDefaultMessages({
    messages: {
      en: store?.store.getState().incident.ibrsValidationRules?.incIncident || {},
    },
  });

  return new SimpleSchema({
    ibrStatus: {
      type: String,
      label: 'IBR Status',
      optional: true,
      custom() {
        const codeIBRStatus = store.store.getState().dictionary.codeIBRStatus;
        const ibsStatusCategory = getCategoryOfCode(codeIBRStatus, this.obj.ibrStatus);

        // NIBRS-Arrestee-Status
        if (incidentHasArrestee(this.obj.offenses) && ibsStatusCategory !== 'cbyarrest') {
          return 'NIBRS-Arrestee-Status';
        }

        // NIBRS-2019.2-203
        if (ibsStatusCategory === 'cexception') {
          if (!incidentHasKnownOffender(this.obj.subjects, this.obj.parties, this.obj.offenses)) {
            return 'NIBRS-2019.2-203';
          }
        }
      },
    },
    ibrSubStatusDate: {
      type: Date,
      label: 'IBR Sub Status Date',
      optional: true,
      custom() {
        const codeIBRStatus = store.store.getState().dictionary.codeIBRStatus;
        const ibsStatusCategory = getCategoryOfCode(codeIBRStatus, this.obj.ibrStatus);

        // NIBRS-Clearance-Status-Date
        if (ibsStatusCategory === 'cexception' && !this.obj.ibrSubStatusDate) {
          return 'NIBRS-Clearance-Status-Date';
        }
      },
    },
  });
};
